import styles from "../VacancyCard.module.scss";
import { SkeletonTable, NoData } from "@/components";
import { useVacancyHistoryQuery } from "@/core/api/vacancy/vacancy";
import { dateToRu } from "@/services/date.service";
import { AvatarItem, Tooltip } from "@aurora/components";
import { Hint } from "@aurora/deprecated";
import { FC } from "react";

interface Props {
  vacancyId: string;
  stateCode: string;
}
const VacancyCardHistory: FC<Props> = ({ stateCode, vacancyId }) => {
  const { data: vacancyHistory, isLoading: isLoadingVacancyHistory } =
    useVacancyHistoryQuery(
      { stateCode, vacancyId },
      { refetchOnMountOrArgChange: true, skip: !vacancyId },
    );

  if (!vacancyId) {
    return <NoData />;
  }

  return (
    <>
      <div className={styles.VacancyHistory}>
        <table>
          <colgroup>
            <col width={"12%"} />
            <col width={"35%"} />
            <col width={"30%"} />
            <col width={"23%"} />
          </colgroup>
          <thead>
            <tr>
              <th>Дата</th>
              <th>
                Описание
                <br />
                события
              </th>
              <th>Комментарий</th>
              <th>Пользователь</th>
            </tr>
          </thead>
          <tbody>
            {!isLoadingVacancyHistory && Array.isArray(vacancyHistory) ? (
              vacancyHistory.map((item: any) => {
                return (
                  <tr key={item.id} className={"py-8"}>
                    <td>{dateToRu(item.createDateTime)}</td>
                    <td>
                      {item.stateTitleFrom && item.stateTitleTo
                        ? `Перевод статуса: Из "${item.stateTitleFrom}" в "${item.stateTitleTo}"`
                        : `${item.stateTitleTo}`}
                    </td>
                    <td>
                      {(item.comment && (
                        <Tooltip
                          portal
                          content={item.comment}
                          placement={"topLeft"}
                          triggerOn="hover"
                        >
                          <span className={styles.VacancyHistoryTruncateCell}>
                            {item.comment}
                          </span>
                        </Tooltip>
                      )) ||
                        "-"}
                    </td>
                    <td>
                      <AvatarItem caption={String(item.author)} />
                    </td>
                  </tr>
                );
              })
            ) : (
              <SkeletonTable rows={10} />
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default VacancyCardHistory;
